import { LABOR_REQ_TYPE_OPTIONS } from '../../../msaas-listing/wizard-steps/labor-metrics/constants';

export const emptyLaborMetricsForm = {
  startDate: '',
  endDate: '',
  numOfShifts: 200,
  hoursPerShift: 8,
  minRvusPerShift: 0,
  numRvusReq: 0,
  laborReqType: LABOR_REQ_TYPE_OPTIONS[0],
};
